
<template>
  <div class="complete_content" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>お問い合わせ完了</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li>お問合せありがとうございました。</li>
            <li>お問合せ内容確認メールを自動送信しました。</li>
          </ul>
        </div>
        <div id="login">
          <div id="login_icon">
            <div>
              <img :src="getImage('common/logo.png')">
            </div>
            <div>
              <label>My size, My lifestyle.</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'

export default {
  name: 'SupportComplete',
  components: {
    'dd-header': Header
  },
  data () {
    return {
    }
  },
  methods: {
    closeMenu: function () {
      this.$refs.menuRef.close()
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/SupportComplete.vue